import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import usersApi from "../api/usersApi";
import { Button } from "./Button";
import { Spinner } from "reactstrap";
import { toast } from "react-toastify";
import { setUserDetails } from "../store/auth/Auth";
import { Eye, EyeOff } from "lucide-react";

const ProfilePage = () => {
  const userData = useSelector((state) => state.auth.userdetails);
  const token = useSelector((state) => state.auth.access_token);
  const [user, setUser] = useState(userData || {});
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState(userData || {});
  const [isSaving, setIsSaving] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showCurrent, setShowCurrent] = useState(false);

   const [passData, setPassData] = useState({
        currentPassword: "",
        newPassword: ""
    });
  const dispatch = useDispatch();

  useEffect(() => {
    if (userData) {
      setUser(userData);
      setFormData(userData);
    }
  }, [userData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSave = async () => {
    setIsSaving(true);
    try {
      const res = await usersApi.updateUser(userData.id, formData, token);
      if (res) {
        dispatch(setUserDetails(formData));
        setUser(formData);
        setIsEditing(false);

        setUser(formData);
        setIsEditing(false);
        toast.success(" Profile updated successfully!");
      }
    } catch (error) {
      console.error("Update failed:", error);
      alert("Failed to update profile");
    } finally {
      setIsSaving(false);
    }
  };
     const handlePassChange = (e) => {
        setPassData({ ...passData, [e.target.name]: e.target.value });
    };

     const handlePasswordUpdate = async (passData) => {
      setLoading(true)
            try {
                await usersApi.updateProfilePassword(passData, token);
                toast.success("Password updated successfully!");
               setPassData({
      currentPassword: "",
      newPassword: "",
    });
                setIsEditing(false);
            } catch (error) {
              const errorMessage =
    error?.response?.data?.message ||
    error?.message ||
    "Failed to update password.";

  toast.error(errorMessage);
                
            }finally{
              setLoading(false)
            }
        };

  return (
    <div>
      <div>
        <div className="px-2 text-gray-800">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold">
            User Profile
          </h2>
          <p className="text-sm sm:text-base text-gray-600">
            Manage your account information
          </p>
        </div>

        <div className="px-2 sm:px-4 md:px-2 bg-white rounded-xl shadow-lg overflow-hidden py-1">
          {isEditing ? (
            <>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-0">
                    Full Name
                  </label>
                  <input
                    type="text"
                    name="fullName"
                    value={formData.fullName || ""}
                    onChange={handleChange}
                    className="w-full px-4 py-1 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                    placeholder="Full Name"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email || ""}
                    onChange={handleChange}
                    className="w-full px-4 py-1 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                    placeholder="Email"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Mobile Number
                  </label>
                  <input
                    type="text"
                    name="mobileNumber"
                    value={formData.mobileNumber || ""}
                    onChange={handleChange}
                    className="w-full px-4 py-1 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                    placeholder="Mobile Number"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Role
                  </label>
                  <select
                    name="role"
                    value={formData.role || ""}
                    onChange={handleChange}
                    disabled
                    className="w-full px-4 py-1 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
                  >
                    <option value="ADMIN">ADMIN</option>
                    <option value="CUSTOMER">CUSTOMER</option>
                    <option value="USER">USER</option>
                  </select>
                </div>
              </div>

              <div className="md:col-span-2 flex flex-row items-center justify-end space-x-3 mt-1 w-full">
                <button
                  type="button"
                  onClick={() => setIsEditing(false)}
                  className="bg-red-50 py-2 px-4 border border-red-300 rounded-md text-sm font-medium text-red-700 hover:bg-red-100"
                >
                  Cancel
                </button>
                {isSaving ? (
                  <Button
                    disabled={isSaving}
                    label={<Spinner size={"sm"} className="mx-10" />}
                  />
                ) : (
                  <Button label="Save Changes" onClick={handleSave} />
                )}
              </div>
             
            </>
          ) : (
            <div>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-1">
                <DetailBlock label="Full Name" value={user?.fullName} />
                <DetailBlock label="Email" value={user?.email} />
                <DetailBlock label="Mobile Number" value={user?.mobileNumber} />
                <DetailBlock label="Role" value={user?.role} />
              </div>

              <div className="flex flex-row items-center justify-end space-x-3 mt-2 mr-4">
                <Button
                  label="Edit Profile"
                  onClick={() => setIsEditing(true)}
                />
              </div>
            </div>
            
          )}
        </div>

       <div className="px-2 sm:px-4 md:px-2 bg-white rounded-xl overflow-hidden py-1 mt-2">
      <h3 className="text-lg font-bold text-gray-900 mb-2 flex items-center">
        <span className="bg-yellow-400 h-2 w-2 rounded-full mr-2"></span>
        Change Password
      </h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-2">
        {/* Current Password */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-0">
            Current Password
          </label>
          <div className="relative">
            <input
              name="currentPassword"
              type={showCurrent ? "text" : "password"}
              value={passData.currentPassword}
              onChange={handlePassChange}
              placeholder="••••••••"
              className="w-full border border-gray-300 rounded-md py-1 px-3 pr-10"
            />
            <button
              type="button"
              onClick={() => setShowCurrent(!showCurrent)}
              className="absolute inset-y-0 right-2 flex items-center text-gray-500 hover:text-gray-700"
            >
              {showCurrent ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </div>

        {/* New Password */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-0">
            New Password
          </label>
          <div className="relative">
            <input
              name="newPassword"
              type={showPassword ? "text" : "password"}
              value={passData.newPassword}
              onChange={handlePassChange}
              placeholder="••••••••"
              className="w-full border border-gray-300 rounded-md py-1 px-3 pr-10"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute inset-y-0 right-2 flex items-center text-gray-500 hover:text-gray-700"
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </div>
      </div>

      <div className="flex items-end justify-end">
        <button
  type="button"
  disabled={loading}
  onClick={() => {
    if (!passData.currentPassword || !passData.newPassword) {
      toast.error("Please fill both password fields");
      return;
    }
    handlePasswordUpdate(passData);
  }}
  className="bg-primary py-2 px-4 border border-transparent rounded-md text-sm font-medium text-white hover:bg-blue-700 flex items-center justify-center min-w-[150px]"
>
  {loading ? (
    <Spinner size="sm" />
  ) : (
    "Change Password"
  )}
</button>

      </div>
    </div>
      </div>
    </div>
  );
};

const DetailBlock = ({ label, value }) => (
  <div className="px-1 py-1  transition-colors">
    <div className="text-[10px] uppercase font-bold text-gray-400 mb-0.5 tracking-tight">
      {label}
    </div>
    <div className="text-sm font-semibold text-gray-800 break-all leading-tight">
      {value || "—"}
    </div>
  </div>
);

export default ProfilePage;
